import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PAGES_DATA, USER_TYPE } from '../utils/constants';

const findPageByPath = (pages, pathname) => {
  for (const page of pages) {
    if (page.link === pathname) {
      return page;
    }

    if (Array.isArray(page.submenu)) {
      const found = findPageByPath(page.submenu, pathname);
      if (found) {
        return page;
      }
    }
  }
  return null;
};

const usePremiumSelectAdminPageAccess = (user) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (user?.type !== USER_TYPE.PREMIUM_SELECT_ADMIN || !Array.isArray(user?.accessLevels)) {
      return;
    }

    const currentPage = findPageByPath(PAGES_DATA, location.pathname);
    const hasAccess = currentPage?.roles?.some(role =>
      user.accessLevels.includes(role)
    );

    if (location?.pathname !== '/' && !hasAccess) {
      navigate('/Unauthorized');
    }
  }, [user, location.pathname, navigate]);
};

export default usePremiumSelectAdminPageAccess;
